import * as React from 'react';
import { readChartRows, columnsOf, formatCell } from './chartRows';

// Renders a visually-hidden <table> of chart rows for agents that execute JS.
// Reads the inline <script type="application/json" data-chart-for="<collection>">
// block that Rails injects adjacent to the NvChart div (see PagesHelper
// #inline_chart_data_scripts). Non-JS agents read the same script block
// directly; this component exists only to surface the data as a table for
// tools that prefer tabular structure. Shares its row source and cell
// formatting with the visible Table view (see DataTable / chartRows).
export default function HiddenDataTable({ collectionName }) {
  const rows = React.useMemo(() => readChartRows(collectionName), [collectionName]);

  if (!rows) return null;

  const headers = columnsOf(rows);

  return (
    <table hidden aria-hidden="true" data-chart-collection={collectionName}>
      <thead>
        <tr>{headers.map(h => <th key={h}>{h}</th>)}</tr>
      </thead>
      <tbody>
        {rows.map((row, i) => (
          <tr key={i}>
            {headers.map(h => <td key={h}>{formatCell(row[h])}</td>)}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
